import React from 'react';
import styled, { ThemeContext } from 'styled-components';
import { Img } from 'react-image';
import { SmallButton, SectionTitle } from '../common/styles';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${props => props.theme.bodyColor};
  width: 100vw;
  padding: ${props => (props.theme.isMobile ? '32px 16px' : '40px 96px')};
  overflow-x: hidden;
`;

const InnerContainer = styled.div`
  display: flex;
  gap: 48px;
  ${props => props.theme.isMobile && `
    gap: 32px;
  `};
  ${props => props.theme.isXLarge && `
    gap: 96px;
  `};
  flex-direction: ${props => (props.theme.isMobile ? 'column' : 'row')};
  width: 100%;
  max-width: 1169px;
  align-items: ${props => (props.theme.isMobile ? 'left' : 'center')};
`;

const SectionTitleExt = styled(SectionTitle)`
  color: white;
  font-size: 40px;
  line-height: 1.3;
  margin: 0;
`;

const Desc = styled.p`
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightBook};
  font-size: 20px;
  line-height: 1.5;
  color: white;
  margin: 0;
`;

const Image = styled(Img)`
  object-fit: cover;
  max-width: ${props => (props.theme.isMobile ? 100 : 48)}%;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  max-width: ${props => (props.theme.isMobile ? 100 : 48)}%;
  gap: 32px;
`;

const Button = styled(SmallButton)`
  background-color: #F1DCA7;
  color: #19202D;
  width: ${props => (props.theme.isMobile ? '100%' : '309px')};

  &:hover {
    background-color: #8C9EBF;
  }
`;

export default function PartnerWithUs() {
  const { partnerWithUsImage } = React.useContext(ThemeContext);

  const goToSolutions = e => {
    e.preventDefault();
    window.location.href = '/company/solutions';
  };

  return (
    <Container id="partner_with_us">
      <InnerContainer>
        <Image src={partnerWithUsImage} />
        <Content>
          <SectionTitleExt>
            Elevate Your Reach: Partner with Australia&apos;s Premier Investor Network
          </SectionTitleExt>
          <Desc>
            Join forces with Livewire to access a curated audience of self-directed investors,
            high-net-worth individuals, wealth advisers, and institutional decision-makers.
            Showcase your financial services or advertise to a highly engaged, financially
            savvy audience.
          </Desc>
          <Button onClick={goToSolutions}>Explore Partnership Opportunities</Button>
        </Content>
      </InnerContainer>
    </Container>
  );
}
